import StyledButton from "components/shared/StyledButton";
import type { DeclarationsCardsData } from "containers/DeclarationPage/utils";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import type { IDeclaration } from "store/contributionStore";
import { updateDeclaration } from "store/contributionStore";
import { useAppDispatch } from "store/store";

import styles from "../../style.module.scss";

interface IValidateDeclarationModal {
    /**
     * Data of declaration being saved.
     */
    declarationData: IDeclaration | DeclarationsCardsData | undefined;
    /**
     * Triggers closing modal.
     */
    handleClose: () => void;
    /**
     * Saves id of declaration just set as done.
     */
    setLastDeclarationDone: Dispatch<SetStateAction<number | undefined>>;
}

/**
 * Within DeclarationPage, modal to save declaration as done.
 */
const ValidateDeclarationModal = ({
    declarationData,
    handleClose,
    setLastDeclarationDone,
}: IValidateDeclarationModal) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();

    const handleSavingDeclaration = async () => {
        if (declarationData) {
            const response = await dispatch(
                updateDeclaration({ declarationId: declarationData.id, data: { declaredAt: new Date() } }),
            );
            if (response.meta.requestStatus === "fulfilled") {
                handleClose();
                setLastDeclarationDone(declarationData.id);
            }
        }
    };

    return (
        <div className={styles["validate-modal"]}>
            <ul>
                <li>{t("Declarations.ValidateModal.Description1")}</li>
                <li>{t("Declarations.ValidateModal.Description2")}</li>
            </ul>
            <StyledButton buttonType="primary" onClick={handleSavingDeclaration}>
                {t("Declarations.ValidateModal.SaveBtn")}
            </StyledButton>
        </div>
    );
};

export default ValidateDeclarationModal;
